import React from 'react'
import Img from 'gatsby-image'
import './timeline.scss'

const Timeline = ({ content, lang, localization }) => {
  if (content && content.xTimeline && content.yTimeline) {

    return (
      <div className="timeline-container">
        { content.heading ? <h3>{content.heading}</h3> : null }
        <Img className="timeline-img horizontal" sizes={content.xTimeline.sizes} />
        <Img className="timeline-img vertical" sizes={content.yTimeline.sizes} />
      </div>
    )
  } else {
    return null
  }
}

export default Timeline


// WEBPACK FOOTER //
// ./src/components/Timeline/timeline.js